<template>
  <div
    style="
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      overflow: hidden;
    "
  >
    <h2>Pages</h2>
    <v-dialog v-model="showNewPageDialog" width="800">
      <NewPageDialog @close="showNewPageDialog = false"></NewPageDialog>
    </v-dialog>
    <div style="display: flex; flex-wrap: wrap; padding-top: 10px">
      <NewItemCard width="225">
        <v-btn text @click="showNewPageDialog = true">
          <v-icon left>mdi-plus</v-icon>New Page
        </v-btn>
      </NewItemCard>
      <v-card
        width="225"
        height="240"
        style="
          margin-right: 10px;
          margin-bottom: 10px;
          display: flex;
          flex-direction: column;
          border-radius: 10px !important;
          overflow: hidden;
        "
        v-for="item in projectPages"
        :key="item.id"
        elevation="0"
        rounded
      >
        <v-card-title
          @click="goToEditorForPage(item)"
          style="cursor: pointer"
          >{{ item.name }}</v-card-title
        >
        <v-card-subtitle>{{ item.url }}</v-card-subtitle>
        <v-card-text>
          <span v-for="user in onlineUsers" :key="user.id">
            <UserAvatar
              v-if="isUserOnPage(user.pageId, item.id)"
              :avatarUrl="user.avatarUrl"
              :fullName="user.fullName"
              :title="user.fullName + ' is working on this page'"
            />
          </span>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="goToEditorForPage(item)">Editor</v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                @click="
                  showEditingPageDialog = true;
                  pageToEdit = item;
                "
                v-on="on"
              >
                <v-icon small>mdi-cog</v-icon>
              </v-btn>
            </template>
            <span>Config</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-btn
            target="_blank"
            color="primary"
            text
            :href="'https://' + selectedProject.computedDomain + item.url"
            title="Preview page"
          >
            <v-icon small style="margin-left: 10px">mdi-open-in-new</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-card v-if="false">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">URL</th>
              <th class="text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in projectPages" :key="item.id">
              <td>{{ item.name }}</td>
              <td>
                <a
                  style="text-decoration: none"
                  :href="'https://' + selectedProject.computedDomain + item.url"
                  target="_blank"
                >
                  {{ "https://" + selectedProject.computedDomain + item.url }}
                  <v-icon small right>mdi-open-in-new</v-icon>
                </a>
              </td>

              <td>
                <v-btn
                  icon
                  @click="
                    showEditingPageDialog = true;
                    pageToEdit = item;
                  "
                >
                  <v-icon small>mdi-cog</v-icon>
                </v-btn>
                <v-btn text @click="goToEditorForPage(item)">
                  Editor
                  <v-icon small right>mdi-arrow-right</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-dialog v-model="showEditingPageDialog" width="800" :scrollable="true">
      <PageConfigCard
        @close="showEditingPageDialog = false"
        :page="pageToEdit"
      ></PageConfigCard>
    </v-dialog>
  </div>
</template>

<script>
import projectMixin from "./project-mixin";
import NewPageDialog from "./NewPageDialog";
import PageConfigCard from "./PageConfigCard";
import UserAvatar from "../../components/UserAvatar";
import NewItemCard from "../../components/NewItemCard";

export default {
  mixins: [projectMixin],
  components: { NewPageDialog, PageConfigCard, UserAvatar, NewItemCard },
  data() {
    return {
      showNewPageDialog: false,
      pagesRefreshing: false,
      showEditingPageDialog: false,
      pageToEdit: false,
    };
  },
  methods: {
    goToEditorForPage(page) {
      this.onPageChange(page);
      this.$router.push("/project/" + this.selectedProject.id + "/editor");
    },
    async refreshPagesTable() {
      this.pagesRefreshing = true;
      setTimeout(async () => {
        await this.getProjectPages(this.selectedProject.id);
        this.pagesRefreshing = false;
      }, 1000);
    },
    isUserOnPage(userPageId, pageId) {
      return userPageId == pageId;
    },
  },
};
</script>